import 'whatwg-fetch'
import '../scss/form.scss'
import '../scss/inline.scss'
import '../scss/messages.scss'
import * as fields   from './fields'
import Form          from './form'
import InlineForm    from './inline'
import * as messages from './messages'

const forms = document.querySelectorAll('form[data-form]')

if (forms)
{
	forms.forEach(el =>
	{
		const form = el.dataset.inline ? new InlineForm() : new Form()
		
		messages.init()
		fields.init(el)
		form.init(el)
	})
}
